import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgTemplateRating32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 65 60"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <defs>
        <path
          id="template-rating-32_svg__a"
          d="M31.688 0c17.5 0 31.687 12.004 31.687 26.813 0 14.808-14.187 26.812-31.687 26.812a36.85 36.85 0 0 1-10.64-1.549l-4.396 4.397c-3.812 3.812-6.9 2.546-6.898-2.866l.003-7.441C3.743 41.286 0 34.419 0 26.813 0 12.004 14.187 0 31.688 0m0 2.438c-16.237 0-29.25 11.011-29.25 24.375 0 6.64 3.213 12.882 8.855 17.46.57.463.901 1.159.901 1.894l-.003 7.441c-.001 3.233.457 3.422 2.738 1.141l4.395-4.396a2.437 2.437 0 0 1 2.428-.61 34.414 34.414 0 0 0 9.936 1.444c16.236 0 29.25-11.011 29.25-24.374 0-13.364-13.014-24.375-29.25-24.375m-16.893 25.64a1.219 1.219 0 0 1 1.522.81c1.883 6.168 7.118 10.721 15.37 10.721 8.239 0 13.469-4.536 15.363-10.694a1.219 1.219 0 0 1 2.33.717c-2.19 7.115-8.299 12.415-17.693 12.415-9.41 0-15.525-5.32-17.701-12.448a1.219 1.219 0 0 1 .81-1.521"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(.813 .75)">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M31.688.25c17.12 0 31 11.64 31 26s-13.88 26-31 26c-3.844 0-7.523-.587-10.92-1.659-4.498 5.143-7.388 7.394-8.67 6.752-1.258-.632-1.631-4.547-1.117-11.744C4.662 40.84.688 33.934.688 26.25c0-14.36 13.879-26 31-26"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M31.688 0c17.5 0 31.687 12.004 31.687 26.813 0 14.808-14.187 26.812-31.687 26.812a36.85 36.85 0 0 1-10.64-1.549l-4.396 4.397c-3.812 3.812-6.9 2.546-6.898-2.866l.003-7.441C3.743 41.286 0 34.419 0 26.813 0 12.004 14.187 0 31.688 0m0 2.438c-16.237 0-29.25 11.011-29.25 24.375 0 6.64 3.213 12.882 8.855 17.46.57.463.901 1.159.901 1.894l-.003 7.441c-.001 3.233.457 3.422 2.738 1.141l4.395-4.396a2.437 2.437 0 0 1 2.428-.61 34.414 34.414 0 0 0 9.936 1.444c16.236 0 29.25-11.011 29.25-24.374 0-13.364-13.014-24.375-29.25-24.375m-16.893 25.64a1.219 1.219 0 0 1 1.522.81c1.883 6.168 7.118 10.721 15.37 10.721 8.239 0 13.469-4.536 15.363-10.694a1.219 1.219 0 0 1 2.33.717c-2.19 7.115-8.299 12.415-17.693 12.415-9.41 0-15.525-5.32-17.701-12.448a1.219 1.219 0 0 1 .81-1.521"
        />
        <mask id="template-rating-32_svg__b" fill="#fff">
          <use xlinkHref="#template-rating-32_svg__a" />
        </mask>
        <g fill="#444" fillRule="nonzero" mask="url(#template-rating-32_svg__b)">
          <path d="M-7.313-9.75h78v78h-78z" />
        </g>
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgTemplateRating32);
export default Memo;
